import React from 'react';

export const Hero = ({ heroIn }) => {
  return (
    <section className="hero">
      <div className="hgrid"/>
      <div className="hwm">NS</div>
      <div className="hcontent">
        <div className={`htag${heroIn ? " in" : ""}`}>Creative Studio · Gulbarga</div>
        <h1 className="hh1">
          {[["WE", ""], ["BUILD", ""], ["BOLD", "red"], ["THINGS.", ""]].map(([w, cls], i) => (
            <span key={i} className="hline">
              <span
                className={`hliner${cls ? ` ${cls}` : ""}${heroIn ? " in" : ""}`}
                style={{ transitionDelay: `${0.26 + i * 0.1}s` }}
              >
                {w}
              </span>
            </span>
          ))}
        </h1>
        <div className={`hfoot${heroIn ? " in" : ""}`}>
          <p className="hdesc">We're a small studio out of Gulbarga building software for real problems — hospitals, schools, career tools, platforms. We care about the craft.</p>
          <a href="#services" className="hcta">See our services →</a>
        </div>
      </div>
    </section>
  );
};